export default __webpack_public_path__ + "static/media/memory.a78d70dd.png";